module.exports = __webpack_public_path__ + "static/media/logo-notext.5a355396.svg";